import React, { useEffect, useRef, useState } from "react";
import "./footerSection.css";

const FooterSection = () => {
  const footerRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (footerRef.current) observer.observe(footerRef.current);

    return () => observer.disconnect();
  }, []);

  return (
    <footer className="fs-footer">
      <section className="fs-section" ref={footerRef}>
        <div className={`fs-content-wrapper ${isVisible ? "visible" : ""}`}>
          <div className="fs-main-layout">
            {/* Left: Logo */}
            <div className="fs-left">
              <img
                src="/KhorDeveloper.png"
                alt="Khor Developer"
                className="fs-logo"
                loading="lazy"
                decoding="async"
              />
            </div>
            {/* Right: Three centered columns */}
            <div className="fs-right-columns">
              <div className="fs-column">
                <h4 className="fs-column-header">Company</h4>
                <nav className="fs-footer-nav">
                  <a href="/">Home</a>
                  <a href="/contact">Contact Us</a>
                </nav>
              </div>

              <div className="fs-column">
                <h4 className="fs-column-header">Resources</h4>
                <nav className="fs-footer-nav">
                  <a href="/auth">Download</a>
                  <a
                    href="https://billing.stripe.com/p/login/bIY3d730f1vmaxafYY"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Customer Portal
                  </a>
                  <a href="/argus-export-guide">ARGUS Export Guide</a>
                  <a href="/request-access">Request Temporary Access</a>
                </nav>
              </div>

              <div className="fs-column">
                <h4 className="fs-column-header">IT/Legal</h4>
                <nav className="fs-footer-nav">
                  <a href="/privacy-policy">Privacy Policy</a>
                  <a href="/subscription-agreement">Subscription Agreement</a>
                  <a href="/it-security">IT & Security</a>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default FooterSection;
